import React from "react";
import { object, string, bool } from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import "./ad-banner.m.css";

export const AdBanner = ({ adbanner, variant = "default", isPreviousEvent }) => {
  // Destructure adbanner properties
  const {
    "image-s3-key": imageS3Key,
    "image-metadata": imageMetadata = {},
    "image-alt": imageAlt = 'Advertisement'
  } = adbanner || {};

  const isS3Key = imageS3Key && !imageS3Key.startsWith('http');

  let bannerClass = variant === "large" ? "ad-banner ad-banner-large" : "ad-banner";
  if (isPreviousEvent) {
    bannerClass += " ad-banner-padding";
  }

  return (
    <div styleName={bannerClass}>
      {imageS3Key && (
        <div styleName="ad-banner-container">
          {isS3Key ? (
            <ResponsiveImage
              slug={imageS3Key}
              metadata={imageMetadata}
              aspectRatio={[900, 168]}
              defaultWidth={900}
              widths={[900, 1800]}
              imgParams={{ auto: ["format", "compress"] }}
              alt={imageAlt}
              styleName="ad-banner-image"
            />
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

AdBanner.propTypes = {
  adbanner: object,
  variant: string,
  isPreviousEvent: bool,
};